import { gql } from '@apollo/client';

export const GET_SERVICES = gql`
  query services {
    services {
      id
      title
      cost
      wholesale_cost
      tax_percent
      use_global_discounts
      created_at
      ean
      vat
    }
  }
`;

export const CREATE_SERVICE = gql`
  mutation createService($input: ServiceInput!) {
    createService(input: $input) {
      id
    }
  }
`;

export const UPDATE_SERVICE = gql`
  mutation updateService($id: Int!, $input: ServiceInput!) {
    updateService(id: $id, input: $input) {
      id
    }
  }
`;

export const DELETE_SERVICE = gql`
  mutation deleteService($id: Int!) {
    deleteService(id: $id) {
      id
    }
  }
`;
